<template>
    <Transition name="noti">
        <NotificationCMS 
            v-if="noti.status"
            :tekst="noti.tekst"
            :icon="noti.icon"
        />
    </Transition>
    <Transition name="popup">
        <WarningComp 
            v-if="alert.status"
            :titel="alert.titel"    
            :tekst="alert.tekst"
            :btn1="alert.btn1"
            :btn2="alert.btn2"
            @actionWarning1="waringAction1"
            @actionWarning2="waringAction2"
        />
    </Transition>
    <PagesHeading 
        :titel="$props.titel"
        @click_new="addPage"
    />
    <div class="pages__open">
        <OpeningEdit 
            v-for="dag in selected"
            :key="dag"
            :d_id="dag.id"
            :dag="dag.dag"
            :open="dag.open"
            :start="dag.start"
            :end="dag.end"
            @edit_day="editData"
        />
    </div>
    <div class="pages__open__buttons">
        <p>{{ edit }}</p>
        <div class="pages__open__buttons__button">
            <p class="button_2" @click="resetData">Reset</p>
            <p class="button" @click="saveData">Opslaan</p>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import NotificationCMS from '../NotificationCMS.vue';
import WarningComp from '../WarningComp.vue';
import PagesHeading from './_templates/comps/PagesHeading.vue';
import OpeningEdit from "./_templates/OpeningEdit.vue";
export default {
    inject:['data', 'status', 'user'],
    props:['titel', 'zoek', 'button'],
    components:{
        WarningComp,
        NotificationCMS,
        PagesHeading,
        OpeningEdit
    },
    data(){
        return{
            db: this.status.db,
            selected: "",
            alert: {
                status: false,
                titel: "",
                tekst: "",
                btn1: "",
                btn2: ""
            },
            noti: {
                status: false,
                tekst: "",
                icon: ""
            },
            edit: ""
        }
    },
    created(){
        this.getData();
    },
    methods:{
        resetData(){
            this.getData();
                let notiTekst = "Wijzigingen zijn ongedaan gemaakt";
                this.edit = {
                    status: false,
                    project:""
                }
                setTimeout(()=>{
                    this.noti = {
                        status: true,
                        tekst: notiTekst,
                        icon: "edit"
                    }
                }, 1000);
                setTimeout(()=>{
                    this.noti = {
                        status: false,
                        tekst: "",
                        icon: ""
                    }
                }, 5000)
        },
        async getData(){
            let data;
            await axios.get(this.status.api + '/get/openingsuren.php',{ 
                params:{ 
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                }
                }).then(function(response){
                    if(response.data.length >= 1){
                        data = response.data;
                    }
                    
                }).catch(function(error){ 
                    console.log(error);
            });
            this.selected = data;
            this.edit = data[0].edit;
        },  
        async saveData(){
            let data;
            let date = new Date();
            const months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
            let editText = "Laatst gewijzigd op " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " om " + date.getHours() + ":" + date.getMinutes() + " door " + this.status.userName;
            await axios.post(this.status.api + '/post/edit-opening.php', {
                server: this.status.api,
                userKey: this.status.userKey,
                userMail: this.status.userMail,
                userPass: this.status.userPass,
                db: this.status.db,
                dagen: this.selected,
                edit: editText,
            }, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(function (response) {
                if(response.status == 200){
                    data = true
                }
            }).catch(function (error) {
                console.error(error);
            }); 

            if(data){
                this.getData();
                let notiTekst = "Openingsuren zijn succesvol bijgewerkt";
                this.edit = {
                    status: false,
                    project:""
                }
                setTimeout(()=>{
                    this.noti = {
                        status: true,
                        tekst: notiTekst,
                        icon: "edit"
                    }
                }, 1000);
                setTimeout(()=>{
                    this.noti = {
                        status: false,
                        tekst: "",
                        icon: ""
                    }
                }, 5000)
            }
        },
        editData(x){
            for(let i = 0; i < this.selected.length; i++){
                if(this.selected[i].id === x.id){
                    this.selected[i].open = x.open;
                    this.selected[i].start = x.start;
                    this.selected[i].end = x.end;
                }
            }
        }
    },
    watch:{
        user: {
        handler(x){
            if(x.status){
                this.getData();
            }
        },
        deep: true
        },
    }
    
}
</script>